// extracted by mini-css-extract-plugin
export default {"form_container":"_reviewForm_form_container__3yh6e","stars":"_reviewForm_stars__g9yAq","wiggle":"_reviewForm_wiggle__QzGFL"};